import type { Certificate } from '@/domain/certificate'
import type { CertificateService } from './CertificateService'
import type { CertificateRepository } from '@/repositories/CertificateRepository'
import type { UserRepository } from '@/repositories/UserRepository'

// Zero-cost implementation of CertificateService (Document 11 §4/§6).
// Generates the Certificate record and hands rendering to CertificatePage
// (client-side view + browser print-to-PDF — no new dependency required).
// CloudSecureCertificateService (P5) implements the same interface against
// the production Certificate Service: server-rendered PDF, a public
// verification URL, and revocation — none of which exist here yet.
export class DevCertificateService implements CertificateService {
  constructor(
    private certificates: CertificateRepository,
    private users: UserRepository
  ) {}

  async generate(userId: string, courseName: string): Promise<Certificate> {
    const user = await this.users.getById(userId)
    if (!user) throw new Error(`Cannot issue a certificate for unknown user: ${userId}`)

    const certificate: Certificate = {
      id: crypto.randomUUID(),
      userId,
      orgId: user.orgId,
      courseName,
      issuedAt: new Date().toISOString(),
      status: 'valid',
      version: 1,
    }
    await this.certificates.save(certificate)
    return certificate
  }
}
